import React from "react";
import "./Footer.scss"
import logo from "../../assets/logo-2.png"
import fb from "../../assets/fb.svg"
import tt from "../../assets/tt.svg"
import insta from "../../assets/insta.svg"
import MapLocationComponent from "./MapLocationComponent";
import { useSelector } from "react-redux";
import loc from "../../assets/location.svg"
import phone from "../../assets/phone.svg"
import loc2 from "../../assets/loc2.svg"
import clock from "../../assets/clock.svg"
import email from "../../assets/email.svg"



const Footer = () => {
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);
    return (
        <div className="PapayaFooter">
            <div className="PapayaFooter-top">
                <div className="PapayaFooter-top-item">
                    <img alt="" src={logo} className="PapayaFooter-top-item-logo" />
                    <div className="PapayaFooter-top-item-content">
                        Discover the culinary heart of Northfield, Ealing at PAPAYA® Restaurant. A family legacy since 2000, we proudly serve authentic Sri Lankan and South Indian dishes, blending traditional spices with warm hospitality.
                    </div>
                    <div className="PapayaFooter-top-item-list">
                        {company?.SocialMedias
                            ?.facebook && company?.SocialMedias
                                ?.facebook !== "" && <div
                                    className="PapayaFooter-top-item-list-item"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.facebook, '_blank')
                                    }}>
                                <img alt="" src={fb} />
                            </div>}
                        {company?.SocialMedias
                            ?.tiktok && company?.SocialMedias
                                ?.tiktok !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.tiktok, '_blank')
                                    }} className="PapayaFooter-top-item-list-item">
                                <img alt="" src={tt} />
                            </div>}
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }} className="PapayaFooter-top-item-list-item">
                                <img alt="" src={insta} />
                            </div>}
                    </div>
                </div>
                <div className="PapayaFooter-top-item">
                    <div className="PapayaFooter-top-item-header">
                        Opening Hours
                    </div>
                    {companyDetails?.openingHours?.map((open, key) => {
                        return (<div key={key} className="PapayaFooter-top-item-time">
                            <div className="PapayaFooter-top-item-time-day">{open.Day}</div><div className="PapayaFooter-top-item-time-val">{open?.Closed ? "Closed" : open.OpenHours?.map((date) => {
                                return (
                                    <div className="PapayaFooter-top-item-time-val">{date.StartTime + " - " + date.EndTime}</div>
                                )
                            })}</div>
                        </div>)
                    })}
                    <div className="PapayaFooter-top-item-header2">
                        Parking
                    </div>
                    <div className="PapayaFooter-top-item-subheader">
                        <img alt="" src={loc2} /> Street Parking
                        Available
                    </div>
                </div>
                <div className="PapayaFooter-top-item">
                    <div className="PapayaFooter-top-item-header">
                        Contact Us
                    </div>
                    <div className="PapayaFooter-top-item-subheader">
                        <img alt="" src={loc} />    Location:
                    </div>
                    <div className="PapayaFooter-top-item-subheader2">
                        {companyDetails?.address?.city}, {companyDetails?.address?.postcode}, {companyDetails?.address?.state}
                    </div>
                    <div className="PapayaFooter-top-item-subheader">
                        <img alt="" src={phone} />   Phone Number :
                    </div>
                    <div className="PapayaFooter-top-item-subheader2">
                        {companyDetails?.contactNumber}
                    </div>
                    <div className="PapayaFooter-top-item-subheader">
                        <img alt="" src={email} />   Email Address :
                    </div>
                    <div className="PapayaFooter-top-item-subheader4">
                        {companyDetails?.email}
                    </div>
                </div>
                <div className="PapayaFooter-top-item">
                    <div className="PapayaFooter-top-item-header">
                        Location
                    </div>
                    {companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                        lng={companyDetails?.address?.lng}
                        borderRadius="12px"
                    />}
                </div>

            </div>
            <div className="PapayaFooter-bottom">
                Copyright © 2025 Papaya. All Rights Reserved.
            </div>

        </div>
    )
}
export default Footer